export default __webpack_public_path__ + "static/media/perosnalTraining.c4a2c13d.JPG";